import { Helper } from "./helper.js";
import { JourneyLegKind } from "../../resourcePlanningScheduler/scheduler.js";
import { JourneyLegModel } from "../../resourcePlanning/resourcePlanning.js";

export class JourneyHelper {
    public static toHHMM(hours): string { 
        return Helper.dates.getSecToHHMM(hours * 60 * 60)
    };
    public static getJourneyEmoji(kind: JourneyLegKind) {
        if (kind == JourneyLegKind.NoGeoData)
            return "🚫";
        if (kind == JourneyLegKind.AirwayCalculation)
            return "🌍";
        if (kind == JourneyLegKind.CarDriving)
            return "🚘";
        return "✈️";
    }
    public static getJourneyServiceType(kind: JourneyLegKind) {
        if (kind == JourneyLegKind.AirwayCalculation)
            return Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SuitableResourcesFilter.Airline");
        if (kind == JourneyLegKind.CarDriving)
            return Helper.getTranslation("WebSMS.SlotPlanning.GeocodingService");
        return "";
    }

    public static getJourneyLegText(leg: JourneyLegModel, wayThereBack: "wayThere" | "wayBack" | "none", slotText: boolean) {
        if (slotText) {
            if (leg != null)
                return JourneyHelper.getJourneyEmoji(leg.Kind)
            else
                return "";
        } else {
            if (leg != null) {
                const textEmoji = JourneyHelper.getJourneyEmoji(leg.Kind)
                let textType = JourneyHelper.getJourneyServiceType(leg.Kind);
                if (textType != "")
                    textType = " (" + textType + ")";

                let textThereBack = "";
                if (wayThereBack != "none")
                    textThereBack = wayThereBack == "wayThere" ? Helper.getTranslation("WebSMS.ServiceReport.Hinreise") + ": " :
                        Helper.getTranslation("WebSMS.ServiceReport.Rückreise") + ": ";

                const textKm = leg.DistanceKm != 0 || leg.Kind == JourneyLegKind.CarDriving ? (leg.DistanceKm).toFixed(2) + Helper.getTranslation("GeoMap.Km") : "";
                const textHHMM = leg.DurationHours != 0 || leg.Kind == JourneyLegKind.CarDriving ? JourneyHelper.toHHMM(leg.DurationHours) : "";

                let textKmHHMM = "";
                if (textKm != "" && textHHMM != "")
                    textKmHHMM = " " + textKm + " - " + textHHMM
                else {
                    if (textKm != "")
                        textKmHHMM = " " + textKm;
                    if (textHHMM != "")
                        textKmHHMM = " " + textHHMM;
                }

                return textThereBack + textEmoji + textKmHHMM + textType;
            } else
                return "-";
        }
    }
}
